/**
 * Hamburger module implementation.
 *
* @author Daniel Koch (https://danielkoch.de)
 * @namespace Tc.Module
 * @class Hamburger
 * @extends Tc.Module
 */
T.Module.Hamburger = T.createModule({
	_configs: {},
	_eventNames: {
		CLICK: 'click',
	},
	_selectors: {},
	_stateClasses: {
		isActive: 'a-hamburger--is-active',
	},

	start: function(resolve) {
		this.$ctx = $(this._ctx);

		this.$ctx.on(this._eventNames.CLICK, () => {
			this.toggleOffcanvas();
		});

		resolve();
	},
	sync() {
		// Called when start() method of all registered modules was called.
	},

	toggleOffcanvas: function(){
		this.$ctx = $(this._ctx);

		this.$ctx.toggleClass(this._stateClasses.isActive);
		this._events.emit('toggleOffcanvas');
	},
});

export default T.Module.Hamburger;
